/**
 * @helper languageSwitcher
 * @description
 * this helper is used to switch language
 * */
import i18n from '@/js/i18n/i18n';

/**
 * @function languageSwitcher
 * switch global locale in i18n
 * @param {string} localeCode
 * */
export const languageSwitcher = (localeCode) => {
  localStorage.setItem('locale', localeCode);
  i18n.global.locale.value = localeCode;
};

export const getLanguage = () => {
  return i18n.global.locale.value;
};
